import type { IAdaptTable } from '@/types/shared-types'

export const useFetchTable = async () => {
  const { locale } = useI18n()
  const route = useRoute()

  async function fetchTable(tableId: string) {
    return await useAsyncData(
      `table-${route.path}-${locale.value}-${tableId}`,
      async () => {
        const response = await $fetch<{ table: IAdaptTable | null }>(
          '/api/v1/contentful/investor/table',
          {
            query: {
              locale: locale.value,
              path: route.path,
              tableId,
            },
          })
        return response?.table ?? null
      })
  }

  return {
    fetchTable,
  }
}
